import {ComponentType, lazy, SVGProps} from 'react';

export type IconComponent = ComponentType<SVGProps<SVGSVGElement>>;

// eslint-disable-next-line -eslint/no-explicit-any
type IconRegistry = Record<string, ComponentType<any>>;

// eslint-disable-next-line -eslint/no-explicit-any
const importSvg = (loader: () => Promise<any>): ComponentType<any> =>
  lazy(() => loader().then((mod) => ({default: mod.default ?? mod})));

export const themeIcons = {
  fallback: importSvg(() => import('./fallback.svg')),
  'action/aspect_ratio': importSvg(() => import('./action/aspect_ratio.svg')),
  'action/check_circle': importSvg(() => import('./action/check_circle.svg')),
  'action/restore': importSvg(() => import('./action/restore.svg')),
  'alert/error': importSvg(() => import('./alert/error.svg')),
  'content/filter_list': importSvg(() => import('./content/filter_list.svg')),
  'navigation/arrow_downward': importSvg(() => import('./navigation/arrow_downward.svg')),
  'navigation/arrow_right': importSvg(() => import('./navigation/arrow_right.svg')),
  'navigation/arrow_upward': importSvg(() => import('./navigation/arrow_upward.svg')),
  'navigation/check': importSvg(() => import('./navigation/check.svg')),
  'navigation/close': importSvg(() => import('./navigation/close.svg')),
} satisfies IconRegistry;

// Registry-derived union: an icon key that is not registered above is a compile
// error at the call site instead of a silently empty icon slot at runtime.
export type ThemeIconKey = Exclude<keyof typeof themeIcons, 'fallback'>;
